import axios from "axios";

const main = async (setNotes, setIsSending) => {
  const URL =
    "https://colab-gsuhacks.azurewebsites.net/api/notes?code=udkrdpyLTcXepHwIj2M12VlvaHJU0rQL14RvC%2F7BhwIiblJB1lTK5w%3D%3D";

  const res = await axios.get(URL);

  if (!res.data) {
    setNotes((prevNotes) => [...prevNotes, ...[note]]);
    setIsSending(false);
  }
  if (res.data) {
    setNotes((prevNotes) => [...prevNotes, ...[note]]);
    setIsSending(false);
  }
};

const note = `
# Hello this is section 1

Lorem ipsum dolor sit amet, consectetur adipiscing elit. \r\n
Quam illa ardentis amores excitaret sui! Cur tandem? Certe, nisi\r\n
 voluptatem tanti aestimaretis. Universa enim illorum ratione cum\r\n
tota vestra confligendum puto. Me igitur ipsum ames oportet, non mea,\r\n
si veri amici futuri sumus. Itaque hic ipse iam pridem est reiectus;\r\n
Duo Reges: constructio interrete. Ergo instituto veterum,\r\n
quo etiam Stoici utuntur, hinc capiamus exordium. \r\n
Ergo illi intellegunt quid Epicurus dicat, ego non intellego?\r\n
An dolor longissimus quisque miserrimus, voluptatem non optabiliorem diuturnitas facit?

# Well this seems more like section 2

Quod si ita se habeat, non possit beatam praestare vitam sapientia.\r\n
`;

export default main;
